import { useCallback, useMemo } from 'react'
import { ScrollText } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchExecutions, AUTO_STR as S, type ExecutionRow } from './automationApi'

/**
 * A26.05 — Журнал выполнения (workflow executions, read-only). Dormant until
 * `/admin/automation/executions` ships. Placeholder permission USERS_VIEW.
 */
export function ExecutionsScreen() {
  const columns = useMemo<AdminColumn<ExecutionRow>[]>(
    () => [
      { key: 'workflow', header: S.workflow, type: 'text' },
      { key: 'status', header: S.status, type: 'text' },
      { key: 'started_at', header: S.startedAt, type: 'text' },
      { key: 'duration_ms', header: S.duration, type: 'number' },
      { key: 'error', header: S.error, type: 'text' },
    ],
    [],
  )
  const fetcher = useCallback(fetchExecutions, [])
  return (
    <>
      <PageHeader title={S.executions} screenId="A26.05" />
      <DataTable<ExecutionRow>
        screenId="A26.05"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        exportable
        emptyState={{ icon: <ScrollText size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
